import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllJobs } from "./FetchAllJobsApi";

const initialState = {
  jobs: [],
  isLoading: false,
  isError: false,
  error: "",
  filterType: "",
  searchText: ''
};

export const fetchAllJobs = createAsyncThunk(
  "fetchAllJobs/getjobs",
  async () => {
    const Jobs = await getAllJobs();
    return Jobs;
  }
);

const jobSlice = createSlice({
  name: "fetchJobs",
  initialState,
  reducers: {
    typeFilter: (state, action) => {
      state.filterType = action.payload;
    },
    lowToHigh: (state, action) => {
      state.jobs.sort((a, b) => {return a.salary - b.salary});
    },
    HighTolow: (state, action) => {
      state.jobs.sort((a, b) => {return b.salary - a.salary});
    },
    searchFilter: (state, action) => {
      state.searchText= action.payload;
    },
    deleteStateJob: (state, action) => {
      state.jobs = state.jobs.filter(job => job.id !== action.payload)
      console.log(state.jobs);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllJobs.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchAllJobs.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.jobs = action.payload;
      })
      .addCase(fetchAllJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.jobs = [];
      });
  },
});

export default jobSlice.reducer;
export const {lowToHigh, HighTolow, typeFilter, searchFilter, deleteStateJob} = jobSlice.actions
